import { TFunction } from "i18next";
import { toast } from "react-toastify";
import { toastResponseError } from "../../../utils/responseMessageHelper";

const MAX_SHOWN_ERRORS = 3;

// The import endpoint is all-or-nothing and returns every row error at once
// ({ errors: ["Row 2: …", …] }) — show the first few, summarize the rest.
export const toastInboundImportErrors = (error: unknown, t: TFunction) => {
  const rowErrors = (error as { data?: { errors?: unknown } })?.data?.errors;

  if (Array.isArray(rowErrors) && rowErrors.length > MAX_SHOWN_ERRORS) {
    const message = [
      ...rowErrors.slice(0, MAX_SHOWN_ERRORS),
      t("inbound.import.moreErrors", {
        amount: rowErrors.length - MAX_SHOWN_ERRORS,
      }),
    ].join("; ");
    toast.error(message, { icon: false, autoClose: 8000 });
    return;
  }

  toastResponseError(error);
};
